// src/modules/app-views/welcome/config.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************

import DocumentProvider from 'components/core/DocumentProvider';
import WelcomeInit from './pages/Init';
import accountService from 'modules/app-views/account/service';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const MODULE_ID = 'welcome';

// *******************************************************************************
// PRE CONFIG
// *******************************************************************************
const preConfigChanges = appId => {
  CONFIG.appId = appId;
};

// *******************************************************************************
// MODULE CONFIGURATION
// *******************************************************************************
const CONFIG = {
  version: 2,
  id: MODULE_ID,
  initialPage: 'init',
  initialParams: {},
  initialQuery: {},
  api: null,
};

// *******************************************************************************
// MODULE PAGES
// *******************************************************************************
const PAGES = {
  init: {
    // ───────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ───────────────────────────────────────────────────────────────────────
    layout: 'page', // 'page' | 'list' | 'document'
    moduleId: MODULE_ID,
    showMyTasksLink: true,
    component: props => (
      <DocumentProvider {...props} hideBackToHomeLink={true}>
        <WelcomeInit />
      </DocumentProvider>
    ),

    // ───────────────────────────────────────────────────────────────────────
    // TOUR
    // ───────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: {
        title: 'tour_first_step_title',
        description: 'tour_first_step_description',
        target: null,
      },
      lastModal: {
        title: 'tour_congratulations_title',
        description: 'tour_congratulations_desc',
        target: null,
        prevButtonProps: { style: { display: 'none' } },
      },
      onFinish: async () => {
        await accountService.putNextStep('explore_the_system');
      },
      triggerConfettiOnFinish: true,
      videoLink: {
        br: null,
        us: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // API & DATA
    // ───────────────────────────────────────────────────────────────────────
    api: {
      url: null,
      params: null,
      query: null,

      // data transformation
      returnAsObject: false,
      dataDecorator: null,

      // initial configuration
      autoFetch: true,
      fetchWithoutSubscription: true,
      removeSubscriptionIdFromHeader: true,
      persistInStore: true,
    },

    // ───────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ───────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: null,
      paramKey: null, // No paramKey - page doesn't fetch by ID
      query: null,
    },

    // ───────────────────────────────────────────────────────────────────────
    // PAGE SETTINGS
    // ───────────────────────────────────────────────────────────────────────
    settings: {
      initialTab: null,
      initialValues: {},
      actions: [],
      showActionsButton: true,
    },

    // ───────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    header: {
      visible: false,
      style: 'default', // 'default' | 'card'

      avatar: {
        visible: true,
        placeholder: 'photo',
      },

      navigation: {
        showTitle: true,
        showBreadcrumb: true,
      },

      buttons: {
        filter: false,
        refresh: false,
        goBack: false,
        parameters: false,
      },

      stats: {
        showTotalRecords: false,
      },

      // Only for style: 'card'
      card: {
        title: null,
        subtitle: null,
        column1: null,
        column2: null,
        column3: null,
        tags: null,
        icons: null,
        footer: null,
      },
    },

    // ───────────────────────────────────────────────────────────────────────
    // TABS CONFIGURATION
    // ───────────────────────────────────────────────────────────────────────
    tabs: {},

    // ───────────────────────────────────────────────────────────────────────
    // CUSTOM COMPONENTS
    // ───────────────────────────────────────────────────────────────────────
    components: {},

    // ───────────────────────────────────────────────────────────────────────
    // LIST SETTINGS (only for layout: 'list')
    // ───────────────────────────────────────────────────────────────────────
    list: {
      table: {
        showLineNumbers: false,
        pagination: {
          initialPage: 1,
          pageSize: 100,
        },
        sorter: {
          field: 'name',
          order: 'asc', // 'asc' | 'desc'
        },
      },

      header: {
        showFolder: false,
        showRecordCount: false,
      },

      actions: {
        columns: [],
      },

      preview: {
        title: 'edit_user',
        showCard: false,
        header: null,
        body: null,
        actions: null,
      },

      filter: {
        component: null,
      },

      behavior: {
        editGoToPage: 'document',
      },
    },
  },
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default { CONFIG, PAGES, preConfigChanges };

// *******************************************************************************
// HELPERS
// *******************************************************************************
